import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './multi.css'

const AiConsultingAndStrategy_MultiListCard = () => {


    const cardDetaisl = [
        {
            title : "What we do & the outcomes",
            list :[
                {
                    list1: "Opportunity mapping:",
                    content :"Assess processes across Service Desk, FinOps, DocOps, HR, and Sales Ops; score impact × feasibility × risk."
                },
                {
                    list1: "Strategy & roadmap:",
                    content :"Prioritize a 90-day AI roadmap quick wins, pilots, and scale tracks; define KPIs (deflection %, MTTR, cost ↓, cycle-time ↓)."
                },
                {
                    list1: "Data & architecture readiness:",
                    content :"Audit sources (KBs, tickets, billing, docs), access patterns, latency, PII zones, and tooling."
                },
                {
                    list1: "Pilot design (agentic):",
                    content :"Draft agent graph + tool catalog (tickets, IaC PRs, document parsers), with human-in-the-loop checkpoints."
                },
                {
                    list1: "Business case:",
                    content :"Model TCO/ROI with success metrics and guardrail costs (eval, logging, approvals)."
                },
                {
                    list1: "Typical outcomes:",
                    content :"30–50% L1 deflection with policy-approved actions, 10–20% cloud savings via PR-only rightsizing, 40–60% document cycle-time reduction"
                },
            ]
        },
        {
            title : "How we deliver",
            list :[
                {
                    list1: "Method:",
                    content :"Discover → Design → Deploy. Discover: stakeholder & process mapping; Design: agent policies, evaluation plan; Deploy: canary, HITL, rollback."
                },
                {
                    list1: "Responsible AI & safety:",
                    content :"Human approvals, allow-listed tools, audit trails, version pinning, bias/fairness checks, red-teaming."
                },
                {
                    list1: "Security & compliance:",
                    content :"SSO/RBAC, least-privilege, encryption, data retention windows; GDPR/DPDP alignment; SOC2/ISO roadmap."
                },
                {
                    list1: "Evaluation & observability:",
                    content :"Offline eval sets + live A/B; traces for tool calls; incident replay."
                },
                {
                    list1: "Deliverables:",
                    content :"90-day roadmap, pilot scope, architecture + data flow, risk/DPIA notes, KPI dashboard spec, adoption plan."
                },
                {
                    list1: "Who it's for:",
                    content :"CIO/CTO, Heads of IT Ops/FinOps/Shared Services, PMO."
                },
                {
                    list1: "Next step:",
                    content :"Book a 20-min fit call to pick your first pilot use case."
                },
            ]
        },
    ]
   



  return (
    <>
    <Row>

 
    {
        cardDetaisl.map((item, index)=>{

            return(

                <Col className='card_margin' lg="6">  

            <Card className='multi_list_card'>
         
                <Card.Title className='multi_list_card_content_title'>{item.title}</Card.Title>
                
            
                <div className='multi_list_card_content'>
                <ul>
                    
                    {
                        item.list.map((newitem, index)=>{

                          

                            return(
                                <li>
                                    {newitem.list1}
                      
                       
                                <p className='list_subitem'>{newitem.content}</p>
                               
                               </li>

                            )

                        })
                    }
                    
                    
                    
                    </ul>
            
                   
                  
            
                </div>
            
            
                
            
            
            
            
            </Card>
            </Col>
            )
           
        })
    }


  


      


    </Row>

  

 

    



    </>

  


  )
}

export default AiConsultingAndStrategy_MultiListCard